import { accentTextClass } from './sectionTone'

/**
 * Archive-aware inline text.
 * parts: string | { text, accent?: true|'highlight'|'emphasis'|'green'|'red'|'primary'|'bold' }[]
 * or a single object { text, accent }
 */
export function normalizeRichParts(input) {
  if (input == null || input === '') return []
  if (typeof input === 'string') return [{ text: input }]
  if (Array.isArray(input)) {
    return input
      .map((p) => (typeof p === 'string' ? { text: p } : p))
      .filter((p) => p?.text)
  }
  if (typeof input === 'object' && input.text) return [input]
  return []
}

/**
 * Renders archive-colored inline spans inside a parent typography class.
 * Accents: green highlight, red emphasis, navy primary+bold.
 */
export default function RichText({ parts, className = '', as: Tag = 'span' }) {
  const list = normalizeRichParts(parts)
  if (!list.length) return null

  return (
    <Tag className={className}>
      {list.map((part, i) => {
        const accent = accentTextClass(part.accent)
        if (!accent) {
          return <span key={i}>{part.text}</span>
        }
        return (
          <span key={i} className={accent}>
            {part.text}
          </span>
        )
      })}
    </Tag>
  )
}
